
import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions';
import ParkingList from './../components/ParkingList';

class ParkingListContainer extends Component {

    componentDidMount() {
        const { fetchAvailableParkings } = this.props;        
        fetchAvailableParkings();
    }

    handleParkingClicked = (parkingId) => {
        this.props.history.push('/parking/' + parkingId);
    }

    render() {
        const { availableParkings, loading, error } = this.props;
        return (
            <ParkingList
                error={error}
                loading={loading}
                availableParkings={availableParkings}

                handleParkingClicked={this.handleParkingClicked}
            />
        );
    }
}

const mapStateToProps = ({ parkingReducer }) => {
    return {
        availableParkings: parkingReducer.parkingList.availableParkings,
        loading: parkingReducer.parkingList.loading,
        error: parkingReducer.parkingList.error
    };
};

const mapDispatchToProps = {
    fetchAvailableParkings: actions.fetchAvailableParkings
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ParkingListContainer);